import { apiSlice } from "../../app/api/apiSlice";

export const fetchEnhancedConditionsTemplateDetailsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		enhancedConditionsTemplateDetails: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/get_enhanced_conditions_template/${credentials.id}`,
				method: "GET",
			}),
		}),
	}),
});

export const { useEnhancedConditionsTemplateDetailsMutation } = fetchEnhancedConditionsTemplateDetailsApiSlice;
